<template>
  <span>{{ animatedValue.toFixed(fixed) }}</span>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { animate } from 'popmotion'

const props = defineProps({
  value: {
    type: [Number, String],
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
})

const animatedValue = ref(0)
const fixed = ref(0)

watch(
  () => props.value,
  (newValue) => {
    fixed.value = typeof newValue === 'number' && newValue % 1 !== 0 ? 1 : 0

    animate({
      from: animatedValue.value,
      to: Number(newValue),
      duration: 1000,
      onUpdate: (latest) => {
        animatedValue.value = latest
      },
    })
  },
  { immediate: true }
)

watch(
  () => props.isLoading,
  (loading) => {
    if (loading) {
      animatedValue.value = 0
    }
  }
)
</script>
